import queryString from 'query-string';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { listingSearchHome } from 'utils/searchHomePages';
import { pathnameEqual } from 'utils/url';

import {
  PAGE_HEADER_NAV,
  PAGE_HEADER_NAV_MAP,
  PAGE_HEADER_PATH_MAP,
} from './PageHeaderConstants';

type Props = {
  isStaff: boolean;
};

export function usePageHeaderIsActive({ isStaff }: Props) {
  const location = useLocation();
  const params = location ? queryString.parse(location.search) : {};

  const isActive = useCallback(
    (type: keyof typeof PAGE_HEADER_NAV_MAP) => {
      const h = listingSearchHome(type);

      if (isStaff) {
        return Boolean(
          location &&
            type !== 'HOME' &&
            (location.pathname.includes(PAGE_HEADER_PATH_MAP[type]) ||
              (type === 'QUEUES' &&
                location.pathname.includes('staff/queues'))),
        ); // non-staff: grad program special-cased
      }

      if (params.type) {
        return Boolean(params.type === type);
      }

      if (params.actionType) {
        return Boolean(params.actionType === type);
      }

      return Boolean(h && pathnameEqual(h, location.pathname));
    },
    [isStaff, location, params.type, params.actionType],
  );

  const navInactive = (
    isStaff ? PAGE_HEADER_NAV.STAFF : PAGE_HEADER_NAV.MAIN
  ).every((t) => !isActive(t));

  return { isActive, navInactive };
}
